import { useQuery } from "@tanstack/react-query";
import { getAllServices } from "../../api/apiServices";
import i18next from "i18next";

const useGetServices = (page = 1, perPage = 15, filters = {}) => {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["services", page, perPage, filters, i18next.language],
        queryFn: () => getAllServices(page, perPage, filters),
    });

    return {
        services: data?.data || {},
        meta: data?.data?.meta || {},
        error,
        isLoading,
        refetch,
    };
};

export default useGetServices;
